export const BRAND_VENDOR_REQUESTS_STORAGE_KEY = 'vendor_brand_requests';

export const defaultBrandRequests = [
  {
    id: 'vendor-brand-request-1',
    producerName: 'Sarvam Maya Productions',
    campaignName: 'Sarvam Maya Brand Integration',
    placementTitle: 'Product Placement in Campaign Content',
    location: 'Kerala Release Circuit',
    mediaType: 'Brand Collaboration',
    placement: 'Hero product visibility across 3 scenes and poster extension',
    requestedDuration: 'Campaign window: 21 days',
    startDate: '2026-04-15',
    budget: 250000,
    artwork: 'Sarvam-Maya-Brand-Integration-Brief.pdf',
    notes: 'Looking for a premium consumer brand tie-in with strong theatrical and promo visibility.',
    status: 'pending',
    requestedAt: '2026-04-04T09:50:00.000Z',
  },
  {
    id: 'vendor-brand-request-2',
    producerName: 'Studio Meridian',
    campaignName: 'Promotions Partner Pitch',
    placementTitle: 'Brand Placement in Promotions',
    location: 'South India',
    mediaType: 'Brand Collaboration',
    placement: 'Online promo creatives, offline event branding, and creator collateral',
    requestedDuration: 'Campaign window: 18 days',
    startDate: '2026-04-18',
    budget: 180000,
    artwork: 'Promotions-Partner-Pitch-Deck.pptx',
    notes: 'Need a fast-turn co-promotion partner for launch video, interview, and event rollout.',
    status: 'pending',
    requestedAt: '2026-04-04T13:20:00.000Z',
  },
  {
    id: 'vendor-brand-request-3',
    producerName: 'Firefly Studios',
    campaignName: 'Packaging Visibility Deal',
    placementTitle: 'Creators on Product Packaging',
    location: 'Tamil Nadu and Kerala',
    mediaType: 'Brand Collaboration',
    placement: 'Partners/creators on retail packaging plus in-store display support',
    requestedDuration: 'Campaign window: 30 days',
    startDate: '2026-03-08',
    budget: 320000,
    artwork: 'Packaging-Visibility-Deal-Deck.pdf',
    notes: 'Completed co-branded packaging campaign with retail distribution support.',
    status: 'completed',
    requestedAt: '2026-02-22T10:05:00.000Z',
    reviewedAt: '2026-02-22T15:10:00.000Z',
    paymentReceivedAt: '2026-02-28T11:45:00.000Z',
  },
  {
    id: 'vendor-brand-request-4',
    producerName: 'Blueframe Entertainment',
    campaignName: 'Merchandising Partner Activation',
    placementTitle: 'Merchandising Partner',
    location: 'Telangana',
    mediaType: 'Brand Collaboration',
    placement: 'Retail merchandise collaboration with launch-week displays',
    requestedDuration: 'Campaign window: 14 days',
    startDate: '2026-03-19',
    budget: 140000,
    artwork: 'Merchandising-Activation-Brief.pdf',
    notes: 'Partner fulfilled the merchandising brief and payment was received on schedule.',
    status: 'completed',
    requestedAt: '2026-03-02T08:20:00.000Z',
    reviewedAt: '2026-03-02T12:40:00.000Z',
    paymentReceivedAt: '2026-03-07T15:30:00.000Z',
  },
];
